import { Badge } from "../../components/ui/Badge";
import { STATE_CHIPS, type TicketView, stateText } from "./tickets";

/**
 * A logged ticket's state on its card (v0.9.0's P2b; the mockup's
 * `stateRow`): the chip, and what it means beside it, e.g. "Open · In
 * Progress · open 2 d". On Axon blue (a selected card), the chip sits on the
 * card's own surface, as the HIPAA badge does (#243), and the words are the
 * selected card's softer white.
 */
export function TicketStateRow({
  ticket,
  now,
  timeZone,
  onBrand = false,
}: {
  ticket: TicketView;
  now: Date;
  timeZone: string;
  onBrand?: boolean;
}) {
  const chip = STATE_CHIPS[ticket.state];
  const { text, warn } = stateText(ticket, now, timeZone);
  const badge = <Badge tone={chip.tone}>{chip.label}</Badge>;
  return (
    <span
      data-part="ticket-state"
      className={"flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[12.5px] " + (onBrand ? "text-white/85" : "text-muted")}
    >
      {onBrand ? <span className="inline-flex rounded-pill bg-card">{badge}</span> : badge}
      {text === null ? null : (
        <span className={warn ? (onBrand ? "font-semibold text-white" : "font-semibold text-status-needs-client-fg") : undefined}>
          {text}
        </span>
      )}
    </span>
  );
}
